import { CONFIGURED_FEATURES, featureEnabled } from 'helpers/feature-flags';
export const ACCESSORIAL_RATE_FIELDS = {
  ACCESSORIAL_TYPE: 'accessorialtype',
  ACCESSORIAL_CODE: 'accesscode',
  RATE: 'rate',
  RATE_TYPE: 'ratetype',
  UNIT: 'units',
  EFFECTIVE_START: 'effectiveStart',
  EFFECTIVE_END: 'effectiveEnd',
  QUOTE_ID: 'quoteId',
  NOTES: 'notes',
  ...featureEnabled(CONFIGURED_FEATURES?.AUTO_APPLY_ACCESSORIAL) ? { AUTO_APPLY: 'autoApply' } : {}
};

export const ACTION = {
  UPSERT: 'upsert',
  REMOVE: 'remove',
};

export const BLANK_ACCESSORIAL_RATE = {
  accessorialtype: '',
  rate: '',
  ratetype: '',
  units: '',
  effectiveStart: '',
  effectiveEnd: '',
  ...featureEnabled(CONFIGURED_FEATURES?.AUTO_APPLY_ACCESSORIAL) ? { autoApply: false } : {}
};

export const BLANK_CUSTOMER = {
  customer: '',
  customerType: '',
  name: '',
};

export const DEFAULT_SEARCH_CUSTOMER_TYPE = 'customer';

export const VALID_CUSTOMER_TYPE = {
  carrier: 'carrier',
  shipper: 'shipper',
};

export const STATUS = {
  CONFIRMED: 'confirmed',
  EXPIRED: 'expired',
};
